import dayjs from "dayjs";
import { FormikProps } from "formik";

import { BsSearch } from "react-icons/bs";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";
import { FaPrint } from "react-icons/fa";

import { TypeofHospitalizationFilterInitialValues } from "@/utils/initialValues/hospitalizationFilter";

import { InternalDepartmentSelect } from "@/components/sintegrada/Selects/InternalDepartmentSelect";
import { HospitalWardSelect } from "@/components/sintegrada/Selects/HospitalWardSelect";
import { AgeGroup } from "@/components/sintegrada/AgeGroup";

type Props = {
	formik: FormikProps<TypeofHospitalizationFilterInitialValues>;
	handlePrint: () => void;
};

export function HospitalizationDashboardFilters({ formik, handlePrint }: Props) {
	const { values, touched, errors } = formik;

	const minDate = dayjs().subtract(2, "years").startOf("day").format("YYYY-MM-DDTHH:mm");
	const maxDate = dayjs().endOf("day").format("YYYY-MM-DDTHH:mm");

	const departmentId = values.department.value?.id;

	const hasStartDateError = touched.startDate && errors.startDate;
	const hasEndDateError = touched.endDate && errors.endDate;

	const hasDateError = hasStartDateError || hasEndDateError;

	return (
		<Form onSubmit={formik.handleSubmit}>
			<div className="d-flex gap-4">
				<Col md={3} className="align-items-center mb-3">
					<Form.Label>Período</Form.Label>

					<div className="d-flex gap-3">
						<InputGroup>
							<Form.Control
								type="datetime-local"
								placeholder="Data inicial"
								min={minDate}
								max={maxDate}
								{...formik.getFieldProps("startDate")}
							/>
						</InputGroup>

						<InputGroup>
							<Form.Control
								type="datetime-local"
								placeholder="data final"
								max={maxDate}
								{...formik.getFieldProps("endDate")}
							/>
						</InputGroup>
					</div>

					{hasDateError && (
						<span className="text-danger">{errors.startDate || errors.endDate}</span>
					)}
				</Col>

				<Col md={2}>
					<AgeGroup
						minAge={values.minAge}
						maxAge={values.maxAge}
						handleChangeMinAge={(value) => formik.setFieldValue("minAge", value)}
						handleChangeMaxAge={(value) => formik.setFieldValue("maxAge", value)}
					/>
				</Col>

				<Col md={2}>
					<Form.Label>Selecionar Setor</Form.Label>

					<InternalDepartmentSelect
						autoSelectFirst
						inputId="internal-department"
						value={values.department}
						onChange={(option) => formik.setFieldValue("department", option)}
					/>

					{touched.department && errors.department && (
						<span className="text-danger">{errors.department.label}</span>
					)}
				</Col>

				<Col md={2}>
					<Form.Label>Selecionar Ala</Form.Label>

					<HospitalWardSelect
						departmentId={departmentId}
						isDisabled={!departmentId}
						value={values.hospitalWard}
						onChange={(option) => formik.setFieldValue("hospitalWard", option)}
					/>

					{touched.hospitalWard && errors.hospitalWard && (
						<span className="text-danger">{errors.hospitalWard.label}</span>
					)}
				</Col>

				<Col className="d-flex align-items-end gap-3 mb-3">
					<Button type="submit" className="text-nowrap">
						<BsSearch className="me-2" />
						Consultar
					</Button>

					<Button
						onClick={handlePrint}
						className="text-white text-nowrap"
						variant="muted"
					>
						<FaPrint className="me-2 text-white" />
						Imprimir
					</Button>
				</Col>
			</div>
		</Form>
	);
}
